import { render } from "./SubjectSafetyModal.vue?vue&type=template&id=3fe96ad9"
import script from "./SubjectSafetyModal.js?vue&type=script&lang=js"
export * from "./SubjectSafetyModal.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__